

  <div id = "global" class="global_view">
    
    <svg width="250" height="250">
      <rect *ngFor="let obj of viewport.objs" [attr.x]='obj.i.j * cell_factor' [attr.y]='obj.i.i * cell_factor' [attr.width]="2" [attr.height]="2" fill="grey" />
    </svg>
    <div class="local" id="local_view"
    [style.width.px] = " viewport.getWidth() / zs.zoom * cell_factor"
    [style.height.px] = " viewport.getHeight() / zs.zoom * cell_factor"
    [cdkDragFreeDragPosition]="local_view.topleft"
    cdkDragBoundary=".global_view"
    (cdkDragMoved)="dragMove($event)"
	  (cdkDragEnded)="dragEnd($event)"
	  (cdkDragStarted)="dragStart($event)"
    cdkDragDisabled = 'false'
    cdkDrag>
    </div>
  </div>





  <!-- <div class="toggle_materials">
    <button mat-stroked-button color="primary" (click)="showColors()">Show Colors</button>
    <button mat-stroked-button color="primary" (click)="showDrafts()">Show Drafts</button>
  </div> -->


<!-- </mat-dialog-content>
 -->


